import { useQuery } from "react-query";
import { publicRequest } from "utils";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { useNavigate } from "react-router-dom";
import { useMeta } from "hooks";

export type useNewsModalContentArgs = {
  id: number;
};

export const useNewsModalContent = ({ id }: useNewsModalContentArgs) => {
  const { setMetaTags } = useMeta();
  const navigate = useNavigate();
  const { language } = useSelector((state: RootState) => state.global);

  const { data: newsContent } = useQuery(
    [language, id, "posts-content"],
    () =>
      publicRequest({
        url: `/api/post/${id}/${language}`,
        method: "get"
      }),
    {
      onSuccess: (res) => {
        setMetaTags(res?.data?.meta);
      },
      onError: () => {
        navigate("/news");
        document.body.classList.remove("fixed_body");
      }
    }
  );

  return {
    newsContent: newsContent?.data
  };
};
